import THDStorageUtils, { SESSION_STORAGE } from '@thd-olt-global/thd-storage-utils';
import {
  DELIMITER, ERROR, GENERIC_ERROR, LEGACY_QUOTES_PAGE_SIZE, NEW_UI_QUOTES_PAGE_SIZE, PRODUCT_LIMIT_ERROR
} from '../components/shared/Constants';

export const getProductsByType = (products) => {
  if (!products?.length) {
    return {
      qcProducts: [],
      nonSharedQcProducts: [],
      majorAppliances: [],
      configurableBlinds: [],
      liveGoods: [],
      discontinuedOutOfStockUnavailable: []
    };
  }

  return {
    qcProducts: products.filter((product) => product.flag === 'QC_PRODUCT'),
    nonSharedQcProducts: products.filter((product) => product.flag === 'NON_SHARED_QC_PRODUCT'),
    majorAppliances: products.filter((product) => product.flag === 'MAJOR_APPLIANCE'),
    configurableBlinds: products.filter((product) => product.flag === 'CONFIGURABLE_BLINDS'),
    liveGoods: products.filter((product) => product.flag === 'LIVE_GOODS'),
    discontinuedOutOfStockUnavailable: products.filter((product) => product.flag === 'DISCONTINUED_OOS_UNAVAILABLE')
  };
};

export const formatProductsforCopy = (products) => {
  return products.map((product) => (
  `Product: ${product?.identifiers?.productLabel || product?.product?.description || 'N/A'}\n\
  SKU: ${product?.identifiers?.storeSkuNumber || product?.product?.sku || 'N/A'}\n\
  Brand: ${product?.identifiers?.brandName || 'N/A'}\n\
  Quantity: ${product?.quantity || product?.product?.quantity || 'N/A'}\n\
  itemId: ${product?.itemId || 'N/A'}\n\
  Type: ${product?.flag}`
  )).join('\n\n');
};

export const saveProjectIdOnSession = (projectId) => {
  if (!projectId) return;

  THDStorageUtils.set(SESSION_STORAGE, { key: 'quote-project-id', value: projectId });
};

export const triggerCloseQuoteAnalytics = (message) => {
  return window.LIFE_CYCLE_EVENT_BUS.trigger('add-to-quote.closeQuote',
    { settings: message }
  );
};

export const triggerErrorAnalytics = (error) => {
  const { graphQLErrors } = error;

  const errorMessage = graphQLErrors?.[0]?.message;
  const id = graphQLErrors?.[0]?.extensions?.Quote_Errors?.[0]?.errors?.[0]?.id;
  const httpStatus = graphQLErrors?.[0]?.extensions?.Quote_Errors?.[0]?.httpStatus;

  return window.LIFE_CYCLE_EVENT_BUS.trigger('add-to-quote.errorAnalytics', {
    error: [{
      type: httpStatus < 500 ? 'error' : 'system',
      displayType: 'inline',
      pageSection: 'add to quote',
      message: errorMessage,
      code: id
    }]
  });
};

export const triggerQuoteAddAnalytics = (eventName, {
  quoteId, startTime, products, productExceptions = []
}) => {
  const elapsedSeconds = Math.floor(Date.now() / 1000) - (startTime || 0);
  const combinedProducts = [...products, ...productExceptions];

  return window.LIFE_CYCLE_EVENT_BUS.trigger(eventName, {
    quoteType: 'online',
    quoteId: quoteId || 'n/a',
    quoteTimeElapsed: elapsedSeconds.toString(),
    item: combinedProducts?.map((product) => ({
      quantity: product?.quantity || 0,
      price: {
        basePrice: (product?.pricing?.value && product?.quantity)
          ? String(Number(product?.pricing?.value) * Number(product?.quantity))
          : 0
      },
      productInfo: {
        sku: product?.itemId || 'n/a'
      },
      productException: (product?.flag || 'n/a').toLowerCase()
    }))
  });
};

export const triggerAdvisoryErrorAnalytics = (message) => {

  return window.LIFE_CYCLE_EVENT_BUS.trigger('add-to-quote.errorAnalytics', {
    error: [{
      type: 'advisory',
      displayType: 'inline',
      pageSection: 'add to quote',
      message,
      code: 'n/a'
    }]
  });
};

export const getQuoteNameError = (value) => {
  const validCharacters = /^[a-zA-Z0-9\s]*$/;
  const isBlank = value.trim().length === 0;
  const isValid = validCharacters.test(value);
  if (!isValid || isBlank) {
    const message = isBlank ? ERROR.EMPTY_QUOTE_NAME : ERROR.INVALID_QUOTE_NAME;
    triggerAdvisoryErrorAnalytics(message);
    return message;
  }
  return null;
};

export const getErrorMessage = (error) => {
  if (!error) return '';

  const { message } = error;

  if (message && /CART_ERR_106_1/.test(message)) {
    return PRODUCT_LIMIT_ERROR;
  }

  return GENERIC_ERROR;
};

// The radio value for an existing quote. Used for both each card's `value` and the RadioGroup's
// `value`, so the two can never disagree (e.g. on a null createdUserId).
export const getQuoteRadioValue = ({ cartId, createdUserId, name }) => (
  `${cartId}${DELIMITER}${createdUserId}${DELIMITER}${name}`
);

// Single source of truth for the quote list page size (first page and Show More / Show Less step).
export const getQuotesPageSize = (showNewATQUI) => (
  showNewATQUI ? NEW_UI_QUOTES_PAGE_SIZE : LEGACY_QUOTES_PAGE_SIZE
);
